(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oright-about-timeline"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.oright-abtl').forEach((section) => {
    const track = section.querySelector('[data-tl-track]');
    if (!track) return;
    const step = () => Math.min(track.clientWidth * 0.7, 400);
    const prev = section.querySelector('[data-tl-prev]');
    const next = section.querySelector('[data-tl-next]');
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oright-announcement"] && !Shopify.designMode) return;
  try {
    
  class OrightRibbon {
    constructor(el) {
      this.el = el;
      this.msgs = Array.from(el.querySelectorAll('.oright-ribbon__msg'));
      this.interval = parseInt(el.dataset.interval, 10) || 4500;
      this.collapsible = el.classList.contains('oright-ribbon--collapsible');
      this.mq = window.matchMedia('(max-width: 900px)');
      this.i = 0;
      this.startRotate();
      if (this.collapsible) {
        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }
      this.mq.addEventListener('change', () => this.startRotate());
    }

    startRotate() {
      clearInterval(this.timer);
      if (!this.mq.matches || this.msgs.length < 2) return;
      this.timer = setInterval(() => {
        this.msgs[this.i].removeAttribute('data-active');
        this.i = (this.i + 1) % this.msgs.length;
        this.msgs[this.i].setAttribute('data-active', 'true');
      }, this.interval);
    }

    onScroll() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = null;
        this.el.classList.toggle('is-collapsed', (window.scrollY || 0) > 12);
      });
    }
  }

  document.querySelectorAll('[data-oright-ribbon]').forEach((el) => new OrightRibbon(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oright-article-body"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var body = document.querySelector('.oright-artbody');
      var nav = document.querySelector('[data-oright-toc]');
      if (body && nav && !nav.dataset.built) {
        nav.dataset.built = '1';
        var hs = body.querySelectorAll('h2');
        hs.forEach(function (h, i) {
          if (!h.id) { h.id = 'sec-' + (i + 1); }
          var a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = h.textContent;
          a.className = 'oright-arttoc__link';
          a.setAttribute('data-target', h.id);
          nav.appendChild(a);
        });
        if (!hs.length) {
          var rail = nav.closest('.oright-artrail__sticky');
          if (rail) {
            var lbl = rail.querySelector('.oright-artrail__label');
            if (lbl) { lbl.style.display = 'none'; }
          }
        } else if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) {
                nav.querySelectorAll('.oright-arttoc__link').forEach(function (l) {
                  l.classList.toggle('is-active', l.getAttribute('data-target') === e.target.id);
                });
              }
            });
          }, { rootMargin: '-20% 0px -70% 0px' });
          hs.forEach(function (h) { io.observe(h); });
        }
      }

      var bar = document.querySelector('[data-oright-progress]');
      if (bar && !bar.dataset.bound) {
        bar.dataset.bound = '1';
        var raf = false;
        var onScroll = function () {
          if (raf) { return; }
          raf = true;
          window.requestAnimationFrame(function () {
            raf = false;
            var el = document.scrollingElement || document.documentElement;
            var max = el.scrollHeight - el.clientHeight;
            bar.style.width = (max > 0 ? Math.min(100, (el.scrollTop / max) * 100) : 0) + '%';
          });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      var copy = document.querySelector('[data-oright-copylink]');
      if (copy && !copy.dataset.bound) {
        copy.dataset.bound = '1';
        copy.addEventListener('click', function () {
          var url = window.location.href;
          if (navigator.clipboard) {
            navigator.clipboard.writeText(url).then(function () {
              copy.classList.add('is-copied');
              setTimeout(function () { copy.classList.remove('is-copied'); }, 1400);
            });
          }
        });
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oright-category-index"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-oright-scrollto]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      var sel = el.getAttribute('data-oright-scrollto');
      var target = sel && document.querySelector(sel);
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oright-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Sort dropdown: auto-submit the GET form on change.
    function initSort() {
      document.querySelectorAll('[data-sort-select]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          if (sel.form && sel.form.requestSubmit) sel.form.requestSubmit();
          else if (sel.form) sel.form.submit();
        });
      });
    }

    // Client-side category filter for the flagship Shop grid. Controls live in
    // both this section (chips) and the Category Index section (rows), so listen
    // at the document level. Each control carries one token in data-oright-filter;
    // each card carries its memberships in data-filters. all_handle = show all.
    function initFilter() {
      var grid = document.querySelector('[data-oright-grid]');
      if (!grid) return;
      var section = grid.closest('.oright-plp') || grid;
      var allHandle = grid.getAttribute('data-oright-grid-all') || 'shop-all';
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-filters]'));
      var insert = grid.querySelector('[data-oright-grid-insert]');
      var emptyEl = section.querySelector('[data-oright-grid-empty]');
      var countEl = section.querySelector('[data-oright-grid-count]');
      var sortCat = section.querySelector('[data-oright-sort-category]');
      var controls = Array.prototype.slice.call(document.querySelectorAll('[data-oright-filter]'));

      function apply(token, scroll) {
        if (!token) token = allHandle;
        var showAll = token === allHandle;
        var shown = 0;
        cards.forEach(function (card) {
          var match = showAll || card.getAttribute('data-filters').split(/\s+/).indexOf(token) !== -1;
          card.hidden = !match;
          if (match) shown++;
        });
        if (insert) insert.hidden = !showAll;
        if (emptyEl) emptyEl.hidden = shown !== 0;
        if (countEl) countEl.textContent = shown;
        controls.forEach(function (el) {
          var on = el.getAttribute('data-oright-filter') === token;
          el.classList.toggle('is-active', on);
          if (el.classList.contains('oright-plp__chip')) {
            if (on) el.setAttribute('aria-current', 'true');
            else el.removeAttribute('aria-current');
          }
        });
        if (sortCat) sortCat.value = showAll ? '' : token;
        try {
          var url = new URL(window.location.href);
          if (showAll) url.searchParams.delete('category');
          else url.searchParams.set('category', token);
          window.history.replaceState({}, '', url);
        } catch (e) {}
        if (scroll) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      controls.forEach(function (el) {
        el.addEventListener('click', function (evt) {
          evt.preventDefault();
          apply(el.getAttribute('data-oright-filter'), el.hasAttribute('data-oright-filter-scroll'));
        });
      });

      // Restore filter from the URL on load (so a sort reload keeps the view).
      var initial = allHandle;
      try {
        var qp = new URL(window.location.href).searchParams.get('category');
        if (qp) initial = qp;
      } catch (e) {}
      apply(initial, false);
    }

    function init() { initSort(); initFilter(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oright-contact-pathways"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var cards = document.querySelectorAll('.oright-ctpath__card');
    cards.forEach(function (card) {
      if (card.dataset.bound) return;
      card.dataset.bound = '1';
      card.addEventListener('click', function () {
        var type = card.getAttribute('data-type');
        var select = document.getElementById('contact-enquiry-type');
        if (!select || !type) return;
        var matched = false;
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value === type || select.options[i].text === type) {
            select.selectedIndex = i;
            matched = true;
            break;
          }
        }
        if (matched) select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oright-header"]) return;
  try {
    
  class OrightHeader {
    constructor(header, menu) {
      this.header = header;
      this.menu = menu;
      this.openBtn = document.querySelector('[data-oright-menu-open]');
      this.closeBtn = menu ? menu.querySelector('[data-oright-menu-close]') : null;

      if (this.openBtn) this.openBtn.addEventListener('click', () => this.open());
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { this.close(); this.closeSearch(); }
      });
      if (this.menu) {
        this.menu.addEventListener('click', (e) => {
          if (e.target.closest('a')) this.close();
        });
      }

      // ---- Search: desktop drawer + mobile menu search-mode ----
      this.searchDrawer = document.querySelector('[data-oright-search]');
      this.searchOpenBtn = document.querySelector('[data-oright-search-open]');
      this.desktopMq = window.matchMedia('(min-width: 901px)');

      if (this.searchOpenBtn) {
        this.searchOpenBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (this.desktopMq.matches) this.openSearch();
          else this.openMenuSearch();
        });
      }
      if (this.searchDrawer) {
        this.searchDrawer.querySelectorAll('[data-oright-search-close]').forEach((b) => {
          b.addEventListener('click', () => this.closeSearch());
        });
      }
      if (this.menu) {
        const menuInput = this.menu.querySelector('[data-oright-search-input]');
        if (menuInput) menuInput.addEventListener('focus', () => this.menu.classList.add('is-searching'));
        const menuClear = this.menu.querySelector('.oright-search__clear');
        if (menuClear) menuClear.addEventListener('click', () => this.menu.classList.remove('is-searching'));
      }

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    openSearch() {
      if (!this.searchDrawer) return;
      this.searchDrawer.hidden = false;
      requestAnimationFrame(() => this.searchDrawer.classList.add('is-open'));
      document.body.style.overflow = 'hidden';
      if (this.searchOpenBtn) this.searchOpenBtn.setAttribute('aria-expanded', 'true');
      const input = this.searchDrawer.querySelector('[data-oright-search-input]');
      if (input) setTimeout(() => input.focus(), 80);
    }

    closeSearch() {
      if (!this.searchDrawer || this.searchDrawer.hidden) return;
      this.searchDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
      if (this.searchOpenBtn) this.searchOpenBtn.setAttribute('aria-expanded', 'false');
      setTimeout(() => { this.searchDrawer.hidden = true; }, 380);
    }

    openMenuSearch() {
      this.open();
      if (this.menu) {
        this.menu.classList.add('is-searching');
        const input = this.menu.querySelector('[data-oright-search-input]');
        if (input) setTimeout(() => input.focus(), 120);
      }
    }

    open() {
      if (!this.menu) return;
      this.menu.hidden = false;
      requestAnimationFrame(() => this.menu.classList.add('is-open'));
      document.body.style.overflow = 'hidden';
      if (this.openBtn) this.openBtn.setAttribute('aria-expanded', 'true');
    }

    close() {
      if (!this.menu || this.menu.hidden) return;
      this.menu.classList.remove('is-open');
      this.menu.classList.remove('is-searching');
      document.body.style.overflow = '';
      if (this.openBtn) this.openBtn.setAttribute('aria-expanded', 'false');
      setTimeout(() => {
        this.menu.hidden = true;
      }, 320);
    }

    onScroll() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = null;
        this.header.classList.toggle('is-scrolled', (window.scrollY || 0) > 12);
      });
    }
  }

  const orightHeaderEl = document.querySelector('[data-oright-header]');
  const orightMenuEl = document.querySelector('[data-oright-menu]');
  if (orightHeaderEl) new OrightHeader(orightHeaderEl, orightMenuEl);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oright-newsletter-popup"]) return;
  try {
    
(function () {
  function init() {
    var root = document.querySelector('[data-oright-nlpop]');
    if (!root || root.__nlpopInit) return;
    root.__nlpopInit = true;
    if (root.getAttribute('data-enabled') === 'false') return;

    var designMode = !!(window.Shopify && window.Shopify.designMode);

    var KEY_DISMISS = 'oright_nlpop_dismissed_at';
    var KEY_SUBSCRIBED = 'oright_nlpop_subscribed';
    var KEY_PENDING = 'oright_nlpop_pending';
    var states = root.querySelector('[data-oright-nlpop-states]');
    var form = root.querySelector('#oright-nlpop-form') || root.querySelector('form');
    var errorEl = root.querySelector('[data-oright-nlpop-error]');
    var lastFocus = null;
    var opened = false;

    function reappearMs() {
      var d = parseInt(root.getAttribute('data-reappear-days'), 10);
      if (isNaN(d)) d = 30;
      return d * 86400000;
    }
    function subscribed() { try { return localStorage.getItem(KEY_SUBSCRIBED) === '1'; } catch (e) { return false; } }
    function inCooldown() {
      try {
        var t = parseInt(localStorage.getItem(KEY_DISMISS), 10);
        return !isNaN(t) && (Date.now() - t) < reappearMs();
      } catch (e) { return false; }
    }
    function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

    function focusables() {
      var nodes = root.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])');
      return Array.prototype.filter.call(nodes, function (el) { return el.offsetParent !== null; });
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function open() {
      if (root.__open) return;
      root.__open = true;
      lastFocus = document.activeElement;
      root.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      var c = root.querySelector('.oright-nlpop__close');
      if (c) c.focus();
      document.addEventListener('keydown', onKey);
    }
    function close() {
      if (!root.__open) return;
      root.__open = false;
      root.classList.remove('is-open');
      document.body.style.overflow = '';
      if (!designMode) set(KEY_DISMISS, String(Date.now()));
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { root.hidden = true; }, 360);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function showSuccess() {
      states.setAttribute('data-state', 'success');
      set(KEY_SUBSCRIBED, '1');
      var btn = root.querySelector('[data-state-success] .oright-btn');
      if (btn) btn.focus();
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-oright-nlpop-close]'), function (el) {
      el.addEventListener('click', function (e) {
        if (el.tagName === 'A') { close(); return; }
        e.preventDefault();
        close();
      });
    });
    var shopLink = root.querySelector('.oright-nlpop__shop');
    if (shopLink) shopLink.addEventListener('click', function () { set(KEY_DISMISS, String(Date.now())); });

    var copyBtn = root.querySelector('[data-oright-nlpop-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-code') || '';
        var done = function () {
          var c = root.querySelector('[data-oright-nlpop-copied]');
          if (c) { c.hidden = false; setTimeout(function () { c.hidden = true; }, 2000); }
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else { done(); }
      });
    }

    if (form) {
      // Native validation (required + type=email) blocks malformed input before
      // this fires, so a submit here means the email is well-formed.
      // The AJAX submit is an optimistic fast path. Shopify's Cloudflare bot
      // protection challenges background POSTs to /contact (returns a 403
      // "cf-mitigated: challenge" page a fetch cannot solve), so any response
      // that is not a clean success falls back to a native full-page submit.
      // A top-level navigation renders and clears the Cloudflare challenge, the
      // signup is processed, and Shopify redirects to ?customer_posted=true, at
      // which point the popup reopens in the success state on reload (KEY_PENDING).
      function nativeSubmit() {
        try { sessionStorage.setItem(KEY_PENDING, '1'); } catch (err) {}
        form.submit();
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
        fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
          .then(function (res) {
            if (res.redirected || (res.url && res.url.indexOf('customer_posted=true') !== -1)) {
              showSuccess();
            } else {
              nativeSubmit();
            }
          })
          .catch(nativeSubmit);
      });
    }

    function maybeOpen() {
      if (opened || root.__open || subscribed() || inCooldown()) return;
      opened = true;
      open();
    }

    if (designMode) {
      // Theme editor: no auto-open timer or exit intent; the popup opens on
      // section select and closes on deselect (handlers at module scope).
      root.__nlpopOpen = open;
      root.__nlpopClose = close;
      return;
    }

    var pending = false;
    try { pending = sessionStorage.getItem(KEY_PENDING) === '1'; } catch (e) {}
    if (pending && location.search.indexOf('customer_posted=true') !== -1) {
      try { sessionStorage.removeItem(KEY_PENDING); } catch (e) {}
      open(); showSuccess();
      return;
    }

    var delay = parseInt(root.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 6;
    setTimeout(maybeOpen, delay * 1000);

    if (root.getAttribute('data-exit-intent') === 'true' && window.matchMedia('(min-width: 750px)').matches) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) maybeOpen();
      });
    }
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:select', function (e) {
      var r = e.target.querySelector('[data-oright-nlpop]');
      if (r && r.__nlpopOpen) r.__nlpopOpen();
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var r = e.target.querySelector('[data-oright-nlpop]');
      if (r && r.__nlpopClose) r.__nlpopClose();
    });
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector('[data-oright-nlpop]');
      if (r) { init(); if (r.__nlpopOpen) r.__nlpopOpen(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oright-partners-directory"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.oright-ptdir');
    roots.forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var chips = root.querySelectorAll('.oright-ptdir__chip');
      var cards = root.querySelectorAll('.oright-ptdir__card');
      var countEl = root.querySelector('[data-count]');
      var emptyEl = root.querySelector('[data-empty]');

      function apply(filter) {
        var shown = 0;
        cards.forEach(function (card) {
          var match = filter === 'All' || card.getAttribute('data-cat') === filter;
          card.hidden = !match;
          if (match) shown++;
        });
        if (countEl) {
          countEl.textContent = shown + (shown === 1 ? ' space' : ' spaces') + (filter === 'All' ? '' : ' · ' + filter);
        }
        if (emptyEl) emptyEl.hidden = shown !== 0;
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (c) { c.classList.remove('is-active'); });
          chip.classList.add('is-active');
          apply(chip.getAttribute('data-filter'));
        });
      });

      var resetBtn = root.querySelector('[data-reset]');
      if (resetBtn) {
        resetBtn.addEventListener('click', function () {
          chips.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-filter') === 'All'); });
          apply('All');
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oright-product-details"]) return;
  try {
    
  class OrightAccordions {
    constructor(root) {
      this.items = Array.from(root.querySelectorAll('.oright-pdp-details__item'));
      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-acc-trigger]');
        const panel = item.querySelector('[data-acc-panel]');
        if (!trigger || !panel) return;
        trigger.addEventListener('click', () => this.toggle(item, trigger, panel));
      });
      window.addEventListener('resize', () => this.resizeOpen());
    }

    toggle(item, trigger, panel) {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      this.items.forEach((other) => {
        if (other === item) return;
        const t = other.querySelector('[data-acc-trigger]');
        const p = other.querySelector('[data-acc-panel]');
        if (t && p) {
          t.setAttribute('aria-expanded', 'false');
          p.style.height = '0px';
        }
      });
      if (isOpen) {
        trigger.setAttribute('aria-expanded', 'false');
        panel.style.height = '0px';
      } else {
        trigger.setAttribute('aria-expanded', 'true');
        panel.style.height = panel.firstElementChild.scrollHeight + 'px';
      }
    }

    resizeOpen() {
      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-acc-trigger]');
        const panel = item.querySelector('[data-acc-panel]');
        if (trigger && panel && trigger.getAttribute('aria-expanded') === 'true') {
          panel.style.height = panel.firstElementChild.scrollHeight + 'px';
        }
      });
    }
  }

  document.querySelectorAll('[data-pdp-accordions]').forEach((el) => new OrightAccordions(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oright-product-hero"]) return;
  try {
    
  class OrightPdpHero {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('.oright-pdp-hero__form');
      this.qtyInput = root.querySelector('[data-pdp-qty-input]');
      this.addPrice = root.querySelector('[data-add-price]');
      this.stickybar = root.querySelector('[data-pdp-stickybar]');
      this.sentinel = root.querySelector('[data-pdp-sentinel]');
      this.buy = root.querySelector('[data-pdp-buy]');
      this.productUrl = root.dataset.productUrl;

      this.gallery = root.querySelector('[data-pdp-gallery]');
      this.leadImg = root.querySelector('.oright-pdp-hero__lead-media img');
      this.stickyThumb = root.querySelector('.oright-pdp-stickybar__thumb img');

      this.bindQty();
      this.bindVariants();
      this.bindSticky();
      this.bindGalleryCounter();
    }

    bindGalleryCounter() {
      const current = this.root.querySelector('[data-gallery-current]');
      if (!this.gallery || !current) return;
      const slides = this.gallery.children;
      let ticking = false;
      const update = () => {
        ticking = false;
        if (!slides.length) return;
        const w = slides[0].offsetWidth + 10;
        const i = Math.min(slides.length, Math.round(this.gallery.scrollLeft / w) + 1);
        current.textContent = Math.max(1, i);
      };
      this.gallery.addEventListener(
        'scroll',
        () => {
          if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
          }
        },
        { passive: true }
      );
    }

    get qty() {
      const v = parseInt(this.qtyInput && this.qtyInput.value, 10);
      return isNaN(v) || v < 1 ? 1 : v;
    }

    setQty(n) {
      const val = Math.max(1, n);
      if (this.qtyInput) this.qtyInput.value = val;
      const sq = this.root.querySelector('[data-sticky-qty]');
      if (sq) sq.textContent = val;
    }

    bindQty() {
      this.root.querySelectorAll('[data-qty-minus]').forEach((b) =>
        b.addEventListener('click', () => this.setQty(this.qty - 1))
      );
      this.root.querySelectorAll('[data-qty-plus]').forEach((b) =>
        b.addEventListener('click', () => this.setQty(this.qty + 1))
      );
      if (this.qtyInput) this.qtyInput.addEventListener('change', () => this.setQty(this.qty));
    }

    bindVariants() {
      const radios = this.root.querySelectorAll('[data-pdp-variant]');
      radios.forEach((r) => r.addEventListener('change', () => this.onVariant(r)));
    }

    onVariant(radio) {
      const price = radio.dataset.variantPrice;
      const title = radio.dataset.variantTitle;
      if (this.addPrice && price) this.addPrice.textContent = ' — ' + price;
      const sp = this.root.querySelector('[data-sticky-price]');
      const sv = this.root.querySelector('[data-sticky-variant]');
      if (sp && price) sp.textContent = price;
      if (sv && title) sv.textContent = title;
      // Swap the lead image to the selected size's own photo (when it has one),
      // so clicking a size shows that size. Variants without an image keep the
      // current photo. On mobile, snap the carousel back to the lead slide.
      // NOTE 2026-07-24: currently DORMANT - the radios no longer emit
      // data-variant-image (disabled in the Liquid until hero-grade per-size
      // photos exist), so this block no-ops and the hero photo stays put.
      if (radio.dataset.variantImage && this.leadImg) {
        // Some size images are very tall bottle cutouts (~1:5); cover-cropping
        // those in the 4/4.4 lead frame shows only a sliver. Letterbox them on
        // the beige lead background instead; normal packshots keep cover.
        this.leadImg.onload = () => {
          const tall = this.leadImg.naturalWidth / this.leadImg.naturalHeight < 0.6;
          this.leadImg.style.objectFit = tall ? 'contain' : '';
          if (tall) this.leadImg.style.padding = '8%';
          else this.leadImg.style.padding = '';
        };
        this.leadImg.src = radio.dataset.variantImage;
        if (radio.dataset.variantSrcset) this.leadImg.srcset = radio.dataset.variantSrcset;
        if (this.stickyThumb && radio.dataset.variantThumb) {
          this.stickyThumb.src = radio.dataset.variantThumb;
          this.stickyThumb.removeAttribute('srcset');
        }
        if (this.gallery && this.gallery.scrollWidth > this.gallery.clientWidth) {
          this.gallery.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }
      if (this.productUrl && radio.value) {
        const url = this.productUrl + '?variant=' + radio.value;
        window.history.replaceState({}, '', url);
      }
    }

    bindSticky() {
      if (!this.stickybar) return;
      // Reference = the post-hero sentinel (its top crossing above the viewport means the
      // hero/buy box has scrolled away). Fall back to the buy box if the sentinel has no box.
      let ref = this.sentinel;
      if (
        !ref ||
        (ref.getBoundingClientRect().height === 0 &&
          getComputedStyle(ref).display === 'none')
      ) {
        ref = this.buy;
      }
      if (!ref) return;
      // A rAF-throttled scroll check (NOT an IntersectionObserver): an IO at threshold 0
      // does not fire when the element jumps from below the viewport to above it without an
      // intersecting frame (fast scroll, Page-Down, anchor jumps), which left the bar hidden.
      // Reading the rect on scroll is bulletproof regardless of scroll speed.
      let ticking = false;
      const update = () => {
        ticking = false;
        const past = ref.getBoundingClientRect().top < 0;
        this.stickybar.classList.toggle('is-visible', past);
      };
      const onScroll = () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
      // The sticky "Add to bag" button adds via the shared cart engine
      // ([data-oright-form-add] -> oright-cart.js), so no submit wiring here.
    }
  }

  document.querySelectorAll('[data-pdp-hero]').forEach((el) => new OrightPdpHero(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oright-product-related"]) return;
  try {
    
  (function () {
    function initRail(section) {
      var grid = section.querySelector('.oright-pdp-related__grid');
      if (!grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.oright-pdp-related__card'));
      if (cards.length < 2) return;
      if (grid.parentNode.querySelector('.oright-raildots')) return;
      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'oright-raildots';
      dotsWrap.setAttribute('aria-hidden', 'true');
      grid.parentNode.insertBefore(dotsWrap, grid.nextSibling);
      var dots = cards.map(function (card, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'oright-raildot';
        b.setAttribute('aria-label', 'Go to item ' + (i + 1));
        b.addEventListener('click', function () {
          var left = card.getBoundingClientRect().left - grid.getBoundingClientRect().left + grid.scrollLeft;
          grid.scrollTo({ left: left, behavior: 'smooth' });
        });
        dotsWrap.appendChild(b);
        return b;
      });
      function setActive(i) { for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === i); }
      setActive(0);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting && e.intersectionRatio >= 0.6) {
              var idx = cards.indexOf(e.target);
              if (idx > -1) setActive(idx);
            }
          });
        }, { root: grid, threshold: [0.6] });
        cards.forEach(function (c) { io.observe(c); });
      }
    }
    document.querySelectorAll('.oright-pdp-related').forEach(initRail);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oright-product-ritual-set"]) return;
  try {
    
  (function () {
    function initRail(section) {
      var grid = section.querySelector('.oright-pdp-set__grid');
      if (!grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.oright-pdp-set__card'));
      if (cards.length < 2) return;
      if (grid.parentNode.querySelector('.oright-raildots')) return;
      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'oright-raildots';
      dotsWrap.setAttribute('aria-hidden', 'true');
      grid.parentNode.insertBefore(dotsWrap, grid.nextSibling);
      var dots = cards.map(function (card, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'oright-raildot';
        b.setAttribute('aria-label', 'Go to item ' + (i + 1));
        b.addEventListener('click', function () {
          var left = card.getBoundingClientRect().left - grid.getBoundingClientRect().left + grid.scrollLeft;
          grid.scrollTo({ left: left, behavior: 'smooth' });
        });
        dotsWrap.appendChild(b);
        return b;
      });
      function setActive(i) { for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === i); }
      setActive(0);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting && e.intersectionRatio >= 0.6) {
              var idx = cards.indexOf(e.target);
              if (idx > -1) setActive(idx);
            }
          });
        }, { root: grid, threshold: [0.6] });
        cards.forEach(function (c) { io.observe(c); });
      }
    }
    document.querySelectorAll('.oright-pdp-set').forEach(initRail);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oright-product-senses"]) return;
  try {
    
  // Mobile autoplay rescue: iOS Safari (especially Low Power Mode / Data Saver)
  // suspends autoplay videos, leaving the poster frame. Kick play() when the
  // video scrolls into view, and again on the first user touch (a user gesture
  // satisfies iOS even in Low Power Mode). Pause off-screen to save battery.
  (function () {
    const vids = document.querySelectorAll('.oright-pdp-senses__video');
    if (!vids.length) return;
    const tryPlay = (v) => {
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    };
    vids.forEach((v) => {
      v.muted = true;
    });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) tryPlay(e.target);
            else e.target.pause();
          });
        },
        { threshold: 0.2 }
      );
      vids.forEach((v) => io.observe(v));
    } else {
      vids.forEach(tryPlay);
    }
    const gestureKick = () => {
      vids.forEach((v) => {
        const r = v.getBoundingClientRect();
        if (v.paused && r.bottom > 0 && r.top < window.innerHeight) tryPlay(v);
      });
    };
    ['touchstart', 'click'].forEach((evt) =>
      document.addEventListener(evt, gestureKick, { once: true, passive: true })
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oright-products-carousel"] && !Shopify.designMode) return;
  try {
    
  class OrightCarousel {
    constructor(section) {
      this.track = section.querySelector('[data-carousel-track]');
      const prev = section.querySelector('[data-carousel-prev]');
      const next = section.querySelector('[data-carousel-next]');
      if (prev) prev.addEventListener('click', () => this.scrollBy(-1));
      if (next) next.addEventListener('click', () => this.scrollBy(1));
    }

    scrollBy(dir) {
      if (!this.track) return;
      const amount = Math.min(this.track.clientWidth * 0.7, 420);
      this.track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }
  }

  document.querySelectorAll('.oright-objects').forEach((s) => new OrightCarousel(s));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oright-ritual-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initDots(section) {
      var track = section.querySelector('[data-ritbuild-track]');
      var dotsWrap = section.querySelector('[data-ritbuild-dots]');
      if (!track || !dotsWrap) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('.oright-ritbuild__card'));
      dotsWrap.innerHTML = '';
      if (cards.length < 2) return;

      var dots = cards.map(function (card, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'oright-ritbuild__dot';
        b.setAttribute('aria-label', 'Go to ritual ' + (i + 1));
        b.addEventListener('click', function () {
          var left = card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
          track.scrollTo({ left: left, behavior: 'smooth' });
        });
        dotsWrap.appendChild(b);
        return b;
      });

      function setActive(i) {
        for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === i);
      }
      setActive(0);

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && e.intersectionRatio >= 0.6) {
              var idx = cards.indexOf(e.target);
              if (idx > -1) setActive(idx);
            }
          });
        }, { root: track, threshold: [0.6] });
        cards.forEach(function (c) { io.observe(c); });
      } else {
        track.addEventListener('scroll', function () {
          var i = Math.round(track.scrollLeft / (track.scrollWidth / cards.length));
          setActive(Math.max(0, Math.min(i, cards.length - 1)));
        }, { passive: true });
      }
    }

    document.querySelectorAll('.oright-ritbuild').forEach(initDots);

    // Reliable scroll to #rituals. The mega-menu "Ritual Sets" link points here
    // (/collections/shop-all#rituals), but this section sits far down a tall,
    // image-heavy page, so the browser's NATIVE hash-scroll can land short - most
    // notably on iOS Safari, where the initial scroll fires before the content
    // above has settled, leaving the user near the top instead of at the builder.
    // Re-assert the scroll explicitly on load (a few times as lazy content
    // reflows) and on in-page hashchange. scroll-margin-top handles the header.
    function scrollToRituals(smooth) {
      var el = document.getElementById('rituals');
      if (!el) return;
      el.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
    }
    if (location.hash === '#rituals') {
      window.addEventListener('load', function () {
        scrollToRituals(false);
        setTimeout(function () { scrollToRituals(false); }, 250);
        setTimeout(function () { scrollToRituals(false); }, 700);
      });
    }
    window.addEventListener('hashchange', function () {
      if (location.hash === '#rituals') scrollToRituals(true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oright-specimen-archive"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.oright-spec').forEach((section) => {
    const track = section.querySelector('[data-spec-track]');
    if (!track) return;
    const prev = section.querySelector('[data-spec-prev]');
    const next = section.querySelector('[data-spec-next]');
    const step = () => Math.min(track.clientWidth * 0.7, 420);
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();
})();
